module.exports = __webpack_public_path__ + "img/event-overview - grayscale.1135e490.svg";